import React from 'react';
import cn from 'classnames';
import Button, { ButtonSize, ButtonVariant } from '@creditflowresearch/uilib/Button';
import IconLock from '@creditflowresearch/uilib/Icon/IconLock';
import useGetLoginUrl from '@/creditflowresearch/ui/common/hooks/useGetLoginUrl';

import styles from './logInButton.module.scss';

interface IProps {
  dataTest?: string,
  variant?: ButtonVariant,
  withIcon?: boolean,
  buttonSize?: ButtonSize,
  className?: string,
}

const LogInButton = ({
  dataTest = 'logInButton',
  className,
  variant = 'solid',
  withIcon = true,
  buttonSize = 'M',
}: IProps) => {
  const loginUrl = useGetLoginUrl();

  return (
    <a href={ loginUrl }>
      <Button
        className={ cn(styles.loginButton, className) }
        variant={ variant }
        dataTest={ dataTest }
        size={ buttonSize }
      >
        Log In
        { withIcon && (
          <IconLock
            className={ styles.lockIcon }
          />
        ) }
      </Button>
    </a>
  );
};

export default LogInButton;
